module.exports = __webpack_public_path__ + "media/theme/sample-card__psn-06b912d3.jpg";